// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
import { SpinnerMethods } from '@/mixins/helpers/SpinnerMethods'

// Import firebase
import { propertiesModel, residentsModel } from '@/firebase/firebase-config'
import moment from 'moment';

export const DeleteRentTerm = {

    /*
	**  Register the mixins
	*/

	mixins: [

        BugsnagService,
        SpinnerMethods

    ],

    /*
	**  Set up the data
	*/

	data: () => ({

        deleted_rent_error: false,
        delete_invoices_processing: false,
        invoice_events_deleted: false,
        invoices_deleted: false,
        get_invoice_events_complete: false,
        invoice_events: [],
        rent_delete_complete: false,
        resident_updated: false,
        property_resident_updated: false,
        unit_updated: false,
        current_updated: false,
        future_updated: false,
        lease_update_complete: false,
        currentTotalBalance: 0,
        currentOutstandingBalance: 0,
        totalMonthlyRent: 0,
        totalFutureBalance: 0,
        invoice_events_counter: 1,
        invoice_counter: 1

    }),

    /*
    **  Watch em'
    */

    watch: {

        deleted_rent_error: {

            immediate: true, // Load on created
            handler(deleted_rent_error) {

                /*
                **  Delete the rent term
                **  @method: @here
                */

                if (deleted_rent_error) this.handleDeleteRentError();

            }

        },

        get_invoice_events_complete: {

            immediate: true, // Load on created
            handler(get_invoice_events_complete) {

                /*
                **  Delete the invoices
                **  @method: @here
                */

                if (!this.deleted_rent_error && get_invoice_events_complete && this.invoice_events.length > 0) this.deleteInvoiceEvents();

            }

        },

        invoice_events_deleted: {

            immediate: true, // Load on created
            handler(invoice_events_deleted) {

                /*
                **  Delete the invoices
                **  @method: @here
                */

                if (!this.deleted_rent_error && invoice_events_deleted) this.deleteInvoices();

            }

        },

        invoices_deleted: {

            immediate: true, // Load on created
            handler(invoices_deleted) {

                /*
                **  Delete the rent term
                **  @method: @here
                */

                if (!this.deleted_rent_error && invoices_deleted) this.deleteRentTerm();

            }

        },

        rent_delete_complete: {

            immediate: true, // Load on created
            handler(rent_delete_complete) {

                /*
                **  Update the resident
                **  @method: @here
                */

                if (!this.deleted_rent_error && rent_delete_complete) this.updateLeaseForDeletedRent();

            }

        },

        lease_update_complete: {

            immediate: true, // Load on created
            handler(lease_update_complete) {

                /*
                **  Update the resident
                **  @method: @here
                */

                if (!this.deleted_rent_error && lease_update_complete) this.updateResidentForDeletedRent();

            }

        },

        resident_updated: {

            immediate: true, // Load on created
            handler(resident_updated) {

                /*
                **  Update the property resident
                **  @method: @here
                */

                if (!this.deleted_rent_error && resident_updated) this.updatePropertyResidentForDeletedRent();

            }

        },

        property_resident_updated: {

            immediate: true, // Load on created
            handler(property_resident_updated) {

                /*
                **  Update the unit
                **  @method: @here
                */

                if (!this.deleted_rent_error && property_resident_updated) this.updateUnitForDeletedRent();

            }

        },

        unit_updated: {

            immediate: true, // Load on created
            handler(unit_updated) {

                /*
                **  Update the property current metrics
                **  @method: @here
                */

                if (!this.deleted_rent_error && unit_updated) this.updatePropertyCurrentMetricsForDeletedRent();

            }

        },

        current_updated: {

            immediate: true, // Load on created
            handler(current_updated) {

                /*
                **  Update the property future metrics
                **  @method: @here
                */

                if (!this.deleted_rent_error && current_updated) this.updatePropertyFutureMetricsForDeletedRent();

            }

        },

        future_updated: {

            immediate: true, // Load on created
            handler(future_updated) {

                /*
                **  Update the property future and current metrics
                **  @method: @here
                */

                if (!this.deleted_rent_error && future_updated) this.finishRentTermDelete();

            }

        },

    },

    /*
	**  Methods
    */
    
    methods: {

        deleteRentTermHandler: function() {

            try {

                /*
                **  If double clicked
                **  @prop: @here
                */

                if (this.delete_invoices_processing) return;

                /*
                **  Show the alert
                **  @service: @SweetAlert2
                */

                this.$swal({

                    title: 'Are you sure you want to delete the rent term?',
                    showCancelButton: true,
                    confirmButtonText: `Delete`,
                    confirmButtonColor: '#18bbf7',
                    cancelButtonText: `Cancel`

                }).then((result) => {

                    /*
                    **  If confirmed
                    */
                    
                    if (result.isConfirmed) {

                        /*
                        **  Set the processing prop
                        **  @prop: @here
                        */

                        this.delete_invoices_processing = true;

                        /*
                        **  Show the spinner
                        **  @method: Mixins/Helpers/SpinnerMethods
                        */

                        this.showSpinner();

                        /*
                        **  Get the invoice events
                        **  @method: @here
                        */

                        if (this.rent_invoices.length > 0) {

                            this.getInvoiceEvents();

                        } else {

                            /*
                            **  Set the invoices deleted prop
                            **  @prop: @here
                            */

                            this.invoices_deleted = true;

                        }

                    } 

                });

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Delete Rent from Firestore',
                    errorType: 'Firestore Database',
                    section: 'Events/Rent',
                    uid: 'pjZj2m5vXtVBvk5fgWR9',
                    error: error
                });

            }

        },

        handleDeleteRentError: function() {

            try {

                /* 
                ** Hide the spinner
                ** @location: Mixins/Helpers/SpinnerMethods
                */

                this.hideSpinner();

                /* 
                ** Display error message
                ** @service: @Window/SweetAlert
                */

                this.$swal('Uh Oh!', 'We ran into a problem trying to delete the rent term.', 'error');

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Unable to handle the delete rent term event.',
                    errorType: 'Firestore Database',
                    section: 'Events/Rent',
                    uid: 'EfoYnzl8i6clk5WetvjD',
                    error: e
                });

            }

        },

        getInvoiceEvents: function() {

            try {

                /*
                **  Loop through em' and get the events
                */

                this.rent_invoices.forEach(invoice => {

                    /*
                    **  Get the events for each invoice
                    **  @service: @Firebase/Firestore
                    */

                    propertiesModel.doc(this.$route.params.id).collection('leases').doc(invoice.relationships.lease).collection('rents').doc(invoice.relationships.rent).collection('invoices').doc(invoice.id).collection('events').get()
                    .then(snapshot => {

                        if (snapshot.empty) return;

                        /*
                        **  Add to the prop
                        **  @prop: @here
                        */

                        snapshot.forEach(doc => {

                            this.invoice_events.push(doc.data());

                        });

                    })
                    .then(() => {

                        /*
                        **  Set the invoice get events prop
                        **  @prop: @here
                        */

                        this.get_invoice_events_complete = true;

                    })
                    .catch(error => {

                        /*
                        **  Set the error prop
                        **  @prop: @here
                        */
    
                        this.deleted_rent_error = true;

                        /*
                        **  Send to Bugsnag
                        **  @service: Bugsnag/BugsnagService
                        */
                    
                        this.reportAuthBugsnagError({
                            title: 'Get the Invoices Events When Deleting a Rent Term.',
                            errorType: 'Firestore Database',
                            section: 'Events/Rent',
                            uid: 'Y2dhZ2qkhDcALJJkByUY',
                            error: error
                        });

                    });

                });

            } catch (e) {

                /*
                **  Set the error prop
                **  @prop: @here
                */

                this.deleted_rent_error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Get the Invoice Events from Firestore When Deleting a Rent Term.',
                    errorType: 'Firestore Database',
                    section: 'Events/Rent',
                    uid: 'xyboCeYjdtR0pKuYQ3Ne',
                    error: e
                });

            }

        },

        deleteInvoiceEvents: function() {

            try {

                /*
                **  Loop through em'
                */

                this.invoice_events.forEach(invoice_event => {

                    /*
                    **  Delete the event
                    **  @service: Firebase/Firestore
                    */

                    propertiesModel.doc(this.$route.params.id).collection('leases').doc(invoice_event.relationships.lease).collection('rents').doc(invoice_event.relationships.rent).collection('invoices').doc(invoice_event.relationships.invoice).collection('events').doc(invoice_event.id).update({
                        'meta.deleted_at': moment().unix()
                    })
                    .then(() => {

                        /*
                        **  Increment the counter
                        */

                        if (this.invoice_events_counter < this.invoice_events.length) this.invoice_events_counter = this.invoice_events_counter + 1;

                    })
                    .then(() => {

                        /*
                        **  Check to see if we can move to the next step
                        **  @prop: @here
                        */

                        if (this.invoice_events_counter == this.invoice_events.length) this.invoice_events_deleted = true;

                    })
                    .catch(error => {

                        /*
                        **  Set the error prop
                        **  @prop: @here
                        */

                        this.deleted_rent_error = true;

                        /*
                        **  Send to Bugsnag
                        **  @service: Bugsnag/BugsnagService
                        */

                        this.reportAuthBugsnagError({
                            title: 'Delete Invoice Event in Firestore',
                            errorType: 'Application',
                            section: 'Events/Rent',
                            uid: 'QkP9vIli0FV9AZc8Qsqv',
                            error: error
                        });

                    });

                });

            } catch (e) {

                /*
                **  Set the error prop
                **  @prop: @here
                */

                this.deleted_rent_error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Delete Invoice Events from Firestore When Deleting a Rent Term.',
                    errorType: 'Firestore Database',
                    section: 'Events/Rent',
                    uid: 'MaJMGoBDkSij3UruN270',
                    error: e
                });

            }

        },

        deleteInvoices: function() {

            try {

                /*
                **  Loop through em' and delete
                */

                this.rent_invoices.forEach(invoice => {

                    /*
                    **  Delete the invoice
                    **  @service: Firebase/Firestore
                    */

                    propertiesModel.doc(this.$route.params.id).collection('leases').doc(invoice.relationships.lease).collection('rents').doc(invoice.relationships.rent).collection('invoices').doc(invoice.id).update({
                        'meta.deleted_at': moment().unix()
                    })
                    .then(() => {

                        /*
                        **  Increment the counter
                        */

                        if (this.invoice_counter < this.rent_invoices.length) this.invoice_counter = this.invoice_counter + 1;

                    })
                    .then(() => {

                        /*
                        **  Check to see if we can move to the next step
                        **  @prop: @here
                        */

                        if (this.invoice_counter == this.rent_invoices.length) this.invoices_deleted = true;

                    })
                    .catch(error => {

                        /*
                        **  Set the error prop
                        **  @prop: @here
                        */

                        this.deleted_rent_error = true;

                        /*
                        **  Send to Bugsnag
                        **  @service: Bugsnag/BugsnagService
                        */
                    
                        this.reportAuthBugsnagError({
                            title: 'Delete an invoice in Firestore',
                            errorType: 'Firestore Database',
                            section: 'Events/Rent',
                            uid: 'kf728DVUDsDoH7VYF621',
                            error: error
                        });

                    });

                });

            } catch (e) {

                /*
                **  Set the error prop
                **  @prop: @here
                */

                this.deleted_rent_error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Delete Invoices from Firestore When Deleting a Rent Term.',
                    errorType: 'Firestore Database',
                    section: 'Events/Rent',
                    uid: 'tyjoh21xxCVrKanFxKpB',
                    error: e
                });

            }

        },

        deleteRentTerm: function() {

            try {

                propertiesModel.doc(this.$route.params.id).collection('leases').doc(this.rent.relationships.lease).collection('rents').doc(this.rent.id).update({
                    'meta.deleted_at': moment().unix()
                })
                .then(() => {

                    if (this.rent.attributes.term == 'current') {

                        /*
                        **  Update all documents related to the rent term
                        **  @prop: @here
                        */

                        this.rent_delete_complete = true;

                    } else {

                        /*
                        **  Just update the current and future property metrics
                        **  @prop: @here
                        */

                        this.unit_updated = true;

                    }

                })
                .catch(error => {

                    /*
                    **  Set the error prop
                    **  @prop: @here
                    */

                    this.deleted_rent_error = true;

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                
                    this.reportAuthBugsnagError({
                        title: 'Delete a rent term in Firestore',
                        errorType: 'Firestore Database',
                        section: 'Events/Rent',
                        uid: 'Ylu3qPv3byzNXuEZ781S',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Set the error prop
                **  @prop: @here
                */

                this.deleted_rent_error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Delete Rent Term from Firestore When Deleting a Rent Term.',
                    errorType: 'Firestore Database',
                    section: 'Events/Rent',
                    uid: 'PJO9aa1wLgD2wnfTk7ug',
                    error: e
                });

            }

        },

        updateLeaseForDeletedRent: function() {

            try {

                if (this.rent.attributes.term == 'current') {

                    propertiesModel.doc(this.$route.params.id).collection('leases').doc(this.rent.relationships.lease).update({
                        'metrics.initial_balance': 0,
                        'metrics.outstanding_balance': 0,
                        'metrics.payments.payments_remaining': 0,
                        'metrics.payments.payments_made': 0,
                        'metrics.rent.total_charges': 0,
                        'relationships.active_rent': null,
                        'meta.updated_at': moment().unix()
                    })
                    .then(() => {

                        /*
                        **  Update the prop
                        **  @prop: @here
                        */

                        this.lease_update_complete = true;

                    })
                    .catch(error => {

                        /*
                        **  Set the error prop
                        **  @prop: @here
                        */

                        this.deleted_rent_error = true;

                        /*
                        **  Send to Bugsnag
                        **  @service: Bugsnag/BugsnagService
                        */
                    
                        this.reportAuthBugsnagError({
                            title: 'Delete a rent term in Firestore',
                            errorType: 'Firestore Database',
                            section: 'Events/Rent',
                            uid: 'Ylu3qPv3byzNXuEZ781S',
                            error: error
                        });

                    });

                } else {

                    /*
                    **  Just update the current and future property metrics
                    **  @prop: @here
                    */

                    this.unit_updated = true;

                }

            } catch (e) {

                /*
                **  Set the error prop
                **  @prop: @here
                */

                this.deleted_rent_error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Delete Rent Term from Firestore When Deleting a Rent Term.',
                    errorType: 'Firestore Database',
                    section: 'Events/Rent',
                    uid: 'PJO9aa1wLgD2wnfTk7ug',
                    error: e
                });

            }

        },

        finishRentTermDelete: function() {

            try {

                /* 
                ** Reset the props
                ** @props: @here
                */

                this.deleted_rent_error = false;
                this.delete_invoices_processing = false;
                this.invoice_events_deleted = false;
                this.invoices_deleted = false;
                this.get_invoice_events_complete = false;
                this.invoice_events = [];
                this.rent_delete_complete = false;
                this.resident_updated = false;
                this.property_resident_updated = false;
                this.unit_updated = false;
                this.current_updated = false;
                this.future_updated = false;

                /* 
                ** Close the menu
                ** @method: Components/Property/Lease/Rent/EditRentMenu
                */

                this.closeEditRentMenu();

                /* 
                ** Hide the spinner
                ** @method: Mixins/Helpers/SpinnerMethods
                */

                this.hideSpinner();

                /* 
                ** Display success message
                ** @service: @Window/SweetAlert
                */

                this.$swal('Success!', 'Your rent term has been deleted.', 'success');

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Unable to Finish the Event for a Deleted Rent Term.',
                    errorType: 'Application',
                    section: 'Delete Rent',
                    uid: 'vBlJTalTzzzKKYRfGERB',
                    error: e
                });

            }

        },

        updateResidentForDeletedRent: function() {

            try {

                residentsModel.doc(this.rent.relationships.resident).update({

                    'attributes.rent.current': 0,
                    'meta.updated_at': moment().unix()
    
                })
                .then(() => {

                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.resident_updated = true;

                })
                .catch(error => {
                    
                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.deleted_rent_error = true;

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Update Resident Current Rent in Firestore',
                        errorType: 'Firestore Database',
                        section: 'Delete Rent',
                        uid: '4YP97qsAkm2fXgyYGtJT',
                        error: error
                    });
    
                });

            } catch (e) {

                /*
                **  Set the prop
                **  @prop: @here
                */

                this.deleted_rent_error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Unable to Query Firestore When Updating a Resident for a Deleted Rent Term.',
                    errorType: 'Application',
                    section: 'Delete Rent',
                    uid: 'Cemsu1x2n8vlzGBNHviM',
                    error: e
                });

            }

		},

        updatePropertyResidentForDeletedRent: function() {

            try {

                propertiesModel.doc(this.rent.relationships.property).collection('residents').doc(this.rent.relationships.resident).update({

                    'attributes.rent.current': 0,
                    'meta.updated_at': moment().unix()
    
                })
                .then(() => {

                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.property_resident_updated = true;

                })
                .catch(error => {
    
                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.deleted_rent_error = true;

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Update Property Resident Current Rent in Firestore',
                        errorType: 'Firestore Database',
                        section: 'Delete Rent',
                        uid: 'BpZ0ZDVzPMkwNTL9HInO',
                        error: error
                    });
    
                });

            } catch (e) {

                /*
                **  Set the prop
                **  @prop: @here
                */

                this.deleted_rent_error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Unable to Query Firestore When Updating a Resident When Deleting a Rent Term.',
                    errorType: 'Application',
                    section: 'Delete Rent',
                    uid: 'lRZnMazfojxfaALQ0iy1',
                    error: e
                });

            }

		},

        updateUnitForDeletedRent: function() {

            try {

                propertiesModel.doc(this.rent.relationships.property).collection('units').doc(this.rent.relationships.unit).update({

                    'attributes.rent.current': 0,
                    'meta.updated_at': moment().unix()
    
                })
                .then(() => {

                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.unit_updated = true;

                })
                .catch(error => {
    
                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.deleted_rent_error = true;

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Update Property Unit Current Rent in Firestore',
                        errorType: 'Firestore Database',
                        section: 'Delete Rent',
                        uid: 'z0LHDizzrvH95PARTAez',
                        error: error
                    });
    
                });

            } catch (e) {

                /*
                **  Set the prop
                **  @prop: @here
                */

                this.deleted_rent_error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Unable to Query Firestore When Updating a Unit When Deleting a Rent Term.',
                    errorType: 'Application',
                    section: 'Delete Rent',
                    uid: 'Zw4pOsMVIpKDnWmbPaaz',
                    error: e
                });

            }

		},

        updatePropertyCurrentMetricsForDeletedRent: function() {

            try {

                /*
                **  Loop through and total up the balance for the property
                */

                if (this.current_rent_terms.length > 0) {

                    this.current_rent_terms.forEach(rent => {

                        /*
                        **  Do not include the newly deleted rent term
                        */

                        if (rent.id !== this.rent.id) {

                            /*
                            **  Set the inidividual rent outstanding balance
                            */

                            let rentOutstandingBalance = rent.metrics.total_balance - rent.metrics.total_paid_amount;

                            /*
                            **  Update the vars
                            */

                            this.currentTotalBalance = this.currentTotalBalance + rent.metrics.total_balance;
                            this.currentOutstandingBalance = this.currentOutstandingBalance + rentOutstandingBalance;
                            this.totalMonthlyRent = this.totalMonthlyRent + rent.attributes.amount;

                        }

                    });

                } else {

                    /*
                    **  Update the vars
                    */

                    this.currentTotalBalance = 0;
                    this.currentOutstandingBalance = 0;
                    this.totalMonthlyRent = 0;

                }

                /*
                **  Update the document
                **  @service: @Firebase/Firestore
                */

                propertiesModel.doc(this.property.id).update({

                    'metrics.units.total_monthly_rent': this.totalMonthlyRent,
                    'metrics.leases.active.outstanding_balance': this.currentOutstandingBalance,
                    'metrics.leases.active.total_balance': this.currentTotalBalance,
                    'meta.updated_at': moment().unix()
    
                })
                .then(() => {

                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.current_updated = true;

                })
                .catch(error => {
    
                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.deleted_rent_error = true;

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Update Property Total Monthly Rent in Firestore',
                        errorType: 'Firestore Database',
                        section: 'Delete Rent',
                        uid: 'Vo9oKO83eb7YmUc9Li2u',
                        error: error
                    });
    
                });

            } catch (e) {

                /*
                **  Set the prop
                **  @prop: @here
                */

                this.deleted_rent_error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Unable to Query Firestore When Updating a Property when Deleting a Rent Term.',
                    errorType: 'Application',
                    section: 'Delete Rent',
                    uid: 'FDfboHrOFOmaYkM2btBY',
                    error: e
                });

            }

		},

        updatePropertyFutureMetricsForDeletedRent: function() {

            try {

                /*
                **  Loop through and total up the future balance for the property
                */

                if (this.future_rent_terms.length > 1) {

                    this.future_rent_terms.forEach(rent => {

                        /*
                        **  If not the just deleted rent
                        */

                        if (this.rent.id !== rent.id) {

                            this.totalFutureBalance = this.totalFutureBalance + rent.metrics.total_balance;

                        } else {

                            this.totalFutureBalance = this.totalFutureBalance + 0;

                        }

                    });

                } else {

                    /*
                    **  Update the vars
                    */

                    this.totalFutureBalance = 0;

                }

                /*
                **  Update the document
                **  @service: @Firebase/Firestore
                */

                propertiesModel.doc(this.property.id).update({

                    'metrics.leases.future.total_balance': this.totalFutureBalance,
                    'meta.updated_at': moment().unix()
    
                })
                .then(() => {

                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.future_updated = true;

                })
                .catch(error => {
    
                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.deleted_rent_error = true;

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Update Property Total Monthly Rent in Firestore',
                        errorType: 'Firestore Database',
                        section: 'Delete Rent',
                        uid: '1vkWci55nMPd9ikKmNsp',
                        error: error
                    });
    
                });

            } catch (e) {

                /*
                **  Set the prop
                **  @prop: @here
                */

                this.deleted_rent_error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Unable to Query Firestore When Updating a Property when Deleting a Rent Term.',
                    errorType: 'Application',
                    section: 'Delete Rent',
                    uid: '2CCcnAfLXVrUt6I8rBRV',
                    error: e
                });

            }

		},

    }

}